@let currentRole = role();

<rds-sidenav [collapsed]="collapsed()" [isExpandable]="!inDrawer()">
  @if (
    currentRole === RoleType.ROOM_HOST ||
    currentRole === RoleType.SERVICE_PROVIDER
  ) {
    <a
      rds-sidenav-menuitem
      [routerLink]="['booking-request']"
      *bshHasAccess="{
        role: currentRole,
        permissions: [Permission.CAN_MANAGE_ROOMBOOKINGS],
      }"
      routerLinkActive="rds-sidenav-menuitem-active">
      <rds-icon namespace="outlined" icon="home"></rds-icon>
      Booking Request
    </a>
    <a
      rds-sidenav-menuitem
      [routerLink]="['room-management']"
      *bshHasAccess="{
        role: currentRole,
        permissions: [Permission.CAN_MANAGE_ROOMS],
      }"
      routerLinkActive="rds-sidenav-menuitem-active">
      <rds-icon namespace="outlined" icon="download"></rds-icon>
      Room Management
    </a>
    <a
      rds-sidenav-menuitem
      [routerLink]="['calendar-view']"
      *bshHasAccess="{
        role: currentRole,
        permissions: [Permission.CAN_MANAGE_CALENDAR],
      }"
      routerLinkActive="rds-sidenav-menuitem-active">
      <rds-icon namespace="outlined" icon="calendar_schedule"></rds-icon>
      Calendar View
    </a>
    <a
      rds-sidenav-menuitem
      [routerLink]="['statistics']"
      *bshHasAccess="{
        role: currentRole,
      }"
      routerLinkActive="rds-sidenav-menuitem-active">
      <rds-icon namespace="outlined" icon="chart_view_histogram"></rds-icon>
      Statistics
    </a>
  }

  @if (currentRole === RoleType.ADMIN || currentRole === RoleType.ROOM_HOST) {
    <a
      rds-sidenav-menuitem
      [routerLink]="['group-management']"
      *bshHasAccess="{
        role: currentRole,
        permissions: [Permission.CAN_MANAGE_USER_GROUP],
      }"
      routerLinkActive="rds-sidenav-menuitem-active">
      <rds-icon namespace="outlined" icon="user_group"></rds-icon>
      User Group Management
    </a>
  }
  <a
    rds-sidenav-menuitem
    href="https://datastudio.google.com/reporting/1f56ee67-2ac7-4bd5-aac5-f33c13d24293/page/KthH"
    target="_blank">
    <rds-icon namespace="outlined" icon="analytics" />
    <div class="external-link-container">
      Usage Statistics
      <rds-icon namespace="outlined" icon="external_link" />
    </div>
  </a>
  <a
    rds-sidenav-menuitem
    href="https://sites.google.com/contractors.roche.com/bookly/"
    target="_blank">
    <rds-icon namespace="outlined" icon="circle_help"></rds-icon>
    <div class="external-link-container">
      Help
      <rds-icon namespace="outlined" icon="external_link" />
    </div>
  </a>
  <a rds-sidenav-menuitem [routerLink]="['/']">
    <rds-custom-icon icon="bookly-short" class="icon"></rds-custom-icon>
    Bookly
  </a>
</rds-sidenav>
